import React, { useEffect } from 'react';
import { Container, Body, ButtonContainer, NavContainer, ButtonInvitation, InputInvitation } from './styles'
import EmailList from '../../EmailList'
import { GrFormClose } from 'react-icons/gr'
import InputSearch from '../../InputSearch';
import { producaov2 } from '../../../../../../services/apis';
import swal from 'sweetalert';


const ModelAddAluno = ({ closeModal, invitationTotal, emails, setEmails, licenseUse }) => {
  const [invitationMode, setInvitationMode] = React.useState(0)
  const [email, setEmail] = React.useState('');
  const [search, setSearch] = React.useState('');
  const [fileSheet, setFileSheet] = React.useState(null);

  const inputRef = React.useRef(null);


  const addEmail = () => {
    if (!checkEmail(email)) return;
    if (invitationTotal <= emails.length) return;
    setEmails([email.trim(), ...emails]);
    setEmail('');
  }

  const checkEmail = (email) => {
    if (!email) return false;
    if (emails.includes(email)) return false;
    if (!email.includes('@') || !email.includes('.')) return false;
    return true;
  }

  const goBack = () => {
    setInvitationMode(0);
    //setEmails([]);
    setEmail('');
  }

  const submitEmails = () => {
    closeModal();
  }

  const handleClickBtn = (index) => {
    setInvitationMode(index);
    setSearch('');
  };

  const uploadEmails = (e) => {
    const [file] = e?.target?.files;
    setFileSheet(file);
  }

  useEffect(() => {
    if (!fileSheet) return;

    readSheet()
  }, [fileSheet]);


  const readSheet = async () => {
    const data = new FormData();
    data.append("file", fileSheet);

    const emailsSheet = await producaov2.post('/emails-by-file', data)
      .then((res) => res.data)
      .catch(err => {
        console.log(err.response);
        return null;
      }).finally(() => setFileSheet(null))


    if (!emailsSheet) {
      swal({
        title: "Erro",
        text: 'Erro ao enviar arquivo, verifique se o arquivo está no formato correto e tente novamente',
      })
      return;
    }

    const emailsValids = [];
    const emailsInvalids = [];

    emailsSheet.forEach(e => {
      if (checkEmail(e)) {
        emailsValids.push(e);
      } else {
        emailsInvalids.push(e);
      }
    });

    if (emailsInvalids.length > 0) {
      swal({
        title: "Erro",
        text: `Os seguintes itens não são emails validos: ${emailsInvalids.join('\n ')}`,
      })
    }

    if (emailsValids.length > (invitationTotal - licenseUse)) {

      swal({
        title: "Erro",
        text: `Você não pode adicionar mais de ${invitationTotal} colaboradores`,
      })
      return;
    }

    setEmails([...emailsValids, ...emails]);
  }

  return (
    <Container>
      <div className='header'>
        <h3>{invitationMode ? 'Convidar Usuários' : 'Adicionar colaboradores'}</h3>
        <button onClick={closeModal}>
          <GrFormClose size={22} />
        </button>
      </div>

      <Body>
        {invitationMode ? (
          <NavContainer>
            {{
              1: <button className='upload_btn' onClick={() => inputRef.current.click()} >
                Upload planilha
                <input type="file" ref={inputRef} onChange={uploadEmails} />
              </button>,
              2: <InputInvitation
                type='text'
                placeholder='Email do convidado'
                className='email_input'
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={invitationTotal <= emails.length}
                onKeyDown={(e) => e.key === 'Enter' && addEmail()}
              />
            }[invitationMode]}

            <div>
              <ButtonInvitation
                active={checkEmail(email)}
                onClick={addEmail}>Enviar convite</ButtonInvitation>

              <button className='go_back' onClick={goBack}>Voltar</button>
            </div>
          </NavContainer>
        ) : (
          <>
            <div className='action_container'>
              <div>
                <button onClick={() => handleClickBtn(1)} >Convidar por planilha</button>
                <button onClick={() => handleClickBtn(2)} >Convidar por e-mail</button>
              </div>

              <InputSearch
                value={search}
                setValue={setSearch}
                placeholder='Pesquisar colaborador'
              />
            </div>

            <div className='infos_data'>
              <p>Convites enviados (0)</p>
              <p>Usuários cadastrados ({licenseUse}/{invitationTotal})</p>
            </div>

          </>
        )}

        <EmailList
          emails={emails}
          setEmails={setEmails}
          search={search}
        />

        <ButtonContainer  >
          <button onClick={submitEmails} >
            Concluir
          </button>
        </ButtonContainer>
      </Body>
    </Container>
  )
}

export default ModelAddAluno;
